import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsUUID, IsOptional } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

export class ListProgramConceptPrerequisitesQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'Filter by source concept ID' })
  @IsUUID()
  @IsOptional()
  sourceProgramConceptId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by target concept ID' })
  @IsUUID()
  @IsOptional()
  targetProgramConceptId?: string

  @ApiPropertyOptional({ type: 'string', description: 'Filter by program version ID' })
  @IsUUID()
  @IsOptional()
  programVersionId?: string
}
